<template>
  <Layout>
    <template #header>
      <Heading>{{ $t('ppm_modal__error_heading') }}</Heading>
      <CloseButton @click="$emit('close')" />
    </template>

    <template #default>
      <div class="es-main-img">
        <img :src="mainImg" alt="" class="es-img" />
      </div>
      <div class="es-main-copy">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <Subheading class="es-text" v-html="message" />
      </div>
    </template>

    <template #footer>
      <HotPinkButton @click="$emit('go-to-financials')">
        {{ $t('ppm_modal__error_button') }}
      </HotPinkButton>
    </template>
  </Layout>
</template>

<script>
import Layout from '../layouts/Layout.vue'
import Heading from '../typography/Heading.vue'
import Subheading from '../typography/Subheading.vue'
import HotPinkButton from '../buttons/HotPinkButton.vue'
import CloseButton from '@/components/shared/Dialogs/CloseButton.vue'

export default {
  components: {
    Layout,
    Heading,
    Subheading,
    HotPinkButton,
    CloseButton,
  },
  props: {
    message: {
      type: String,
      default() {
        return this.$t('ppm_modal__error_subheading')
      },
    },
  },
  data() {
    return {
      mainImg: require('../assets/error.png'),
    }
  },
}
</script>

<style lang="postcss" scoped>
.es-main-img {
  /* Base */
  @apply tw-flex tw-justify-center;
}

.es-img {
  /* Base */
  @apply tw-w-[286px] tw-h-[214px] tw-object-contain;
}

.es-main-copy {
  /* Base */
  @apply tw-flex tw-justify-center tw-mb-9;

  /* Desktop */
  @apply lg:tw-mb-0;
}

.es-text {
  /* Base */
  @apply tw-max-w-[316px] tw-mb-0;

  /* Desktop */
  @apply lg:tw-max-w-[620px];
}
</style>
